import backend from "./backend";

export const getProducts = (
  dynamicsId,
  pageNumber,
  pageSize,
  searchTerm,
  Categoria,
  Rubro,
  SubRubro,
  promocion
) => {
  promocion = promocion === "LANZAMIENTOS" ? "LANZAMIENT" : promocion;

  const params = new URLSearchParams({
    pageNumber,
    pageSize,
    searchTerm,
    Categoria,
    Rubro,
    SubRubro,
    promocion,
  });

  return backend.get(`product/customer/${dynamicsId}?${params.toString()}`);
};

export const getProduct = (productId, dynamicsId) => {
  return backend.get(
    `product/${encodeURIComponent(productId)}/customer/${dynamicsId}`
  );
};

export const getPresentaciones = (productId) => {
  return backend.get(`product/presentaciones/${encodeURIComponent(productId)}`);
};

export const getDescuento = (productId, customerId, qty) => {
  return backend.get(
    `product/${encodeURIComponent(
      productId
    )}/descuento/customer/${customerId}/qty/${qty}`
  );
};
export const getValidarCarga = (productId, qty) => {
  return backend.get(
    `product/${encodeURIComponent(productId)}/validate/qty/${qty}`
  );
};

export const getTipologias = (priceLevel) => {
  return backend.get(
    `product/categorias?priceLevel=${encodeURIComponent(priceLevel)}`
  );
};
export const getAlicuota = (dynamicsId) => {
  return backend.get(`/customer/${dynamicsId}/alicuota`);
};
export const getCustomer = (customerNumber) => {
  return backend.get(`customer/${customerNumber}`);
};

export const getCustomerAddresses = (customerId) => {
  return backend.get(`customer/${customerId}/addresses`);
};

export const getCustomersBySalesPerson = (sellerId, searchTerm) => {
  return backend.get(
    `customer?salesPersonId=${sellerId}&searchTerm=${searchTerm}`
  );
};

export const postOrder = (formData) => {
  return backend.post("weborder/checkout", formData);
};

export const getWebOrders = (status) => {
  const params = new URLSearchParams(status.map((x) => ["status", x]));

  return backend.get(`weborder?${params.toString()}`);
};

export const getWebOrdersByCustomer = (customerId, status) => {
  const params = new URLSearchParams(status.map((x) => ["status", x]));

  return backend.get(`weborder/customer/${customerId}?${params.toString()}`);
};

export const getWebOrderDetails = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/detail`);
};
export const getWebOrderDiscountsDetails = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/discountdetail`);
};

export const deleteWebOrder = (webOrderId) => {
  return backend.delete(`weborder/${webOrderId}`);
};

export const getWebOrderCustomerAddresses = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/customeraddresses`);
};

export const approveWebOrder = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/approve`);
};

export const getSalesAsigned = (rol, customerId) => {
  return backend.get(`customer/${customerId}/sales/${rol} `)
}
export const getSalesZone = (customerId) => {
  return backend.get(`customer/${customerId}/zone`)
}

export const getSalesClients = (customerId, zone) => {
  return backend.get(`customer/${customerId}/zone/${zone}`)
}

